import React from "react";
import { FaInstagram } from "react-icons/fa";
import { MdOutlineEmail } from "react-icons/md";

export default function Header() {
  return (
    <div>
      <div className="z-30 fixed top-0 left-0 pl-5 sm:pl-12 h-[80px] flex items-center">
        <span className="text-primary text-sm sm:text-base">susan ma events</span>
      </div>
      <div className="z-30 fixed top-0 right-0 pr-5 sm:pr-12 h-[80px] flex items-center">
        <a href="mailto:susanmaevents@gmail.com">
          <MdOutlineEmail className="mr-2 text-xl text-primary" />
        </a>
        <a href="https://www.instagram.com/susanmaevents/">
          <FaInstagram className="text-xl text-primary" />
        </a>
      </div>
    </div>
  );
}